import { applyTokens } from "../../../utilities/applyTokens.js";
const formControl = (tokens) => {
    const { checkbox, toggle, formField, radioButtonArray } = tokens.component;
    return {
        MuiFormControl: {
            defaultProps: {
                variant: "outlined",
            },
            styleOverrides: {
                root: {
                    "&+.MuiFormLabel-root": {
                        paddingTop: formField.gap.value,
                    },
                    "& .MuiFormGroup-root[role='radiogroup']": {
                        ".MuiFormControlLabel-labelPlacementEnd": Object.assign({}, applyTokens(radioButtonArray.radioButton)),
                    },
                    "& .MuiFormGroup-root.MuiFormGroup-row[role='radiogroup']": {
                        gap: radioButtonArray.gap.value,
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginLeft: 0,
                    marginRight: 0,
                    ".MuiFormControlLabel-label": applyTokens(checkbox.label),
                },
                labelPlacementStart: {
                    "&:has(.MuiSwitch-root)": {
                        gap: toggle.label.leading.paddingRight.value,
                    },
                },
                labelPlacementEnd: {
                    "&:has(.MuiSwitch-root), &:has(.MuiCheckbox-root)": {
                        gap: toggle.label.trailing.paddingLeft.value,
                        ".MuiFormControlLabel-label": Object.assign(Object.assign({}, applyTokens(checkbox.label)), { "&.Mui-disabled": {
                                color: checkbox.label.disabled.color.value,
                            } }),
                    },
                    labelPlacementEnd: {
                        "&:has(.MuiCheckbox-root)": {
                            gap: checkbox.gap.value,
                        },
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    "&&": Object.assign(Object.assign({ position: "relative", transform: "none", paddingBottom: formField.gap.value }, applyTokens(formField.label)), { "&+.MuiFormHelperText-root": {
                            paddingTop: 0,
                            paddingBottom: formField.gap.value,
                        } }),
                    "&.MuiFormLabel-colorInfo": Object.assign({}, applyTokens(formField.help)),
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    "&&": Object.assign(Object.assign({ margin: 0, paddingTop: formField.gap.value }, applyTokens(formField.help)), { "&.Mui-error": applyTokens(formField.error) }),
                },
            },
        },
    };
};
export default formControl;
//# sourceMappingURL=formControl.js.map